<template>
  <div>
    <div>
      <div >
        <InputSearch class="mb-3" @clickSearch="onSearch" :search="search" :placeholder="'ค้นหา'" />
        <v-layout row wrap dense class="mb-3">
          <v-flex xs6 style="display: flex; align-items: center">
            <Typography h2 bold label="แบบฟอร์มโครงการ" />
          </v-flex>
          <v-flex xs6 style="display: flex; align-items: flex-end; justify-content: flex-end">
            <div class="text-xs-right" style="display: flex; align-items: flex-end">
              <v-btn
                variant="outlined"
                v-tooltip="'เพิ่ม'"
                @click="showCustomform"
                :loading="loading"
                icon
                color="#BECCDB"
                style="border-radius: 50% !important"
              >
                <img src="/static/img/Add.png" alt class="responsive-img" style="height: 20px" />
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </div>
      <v-layout class="my-5" justify-center v-if="loading">
        <v-progress-circular
          :size="100"
          :width="10"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-layout>
      <div v-else>
        <v-data-table
          :headers="headers"
          :items="filteredform"
          hide-actions
          select-all
          item-key="name"
          class="fixTable"
        >
          <template v-slot:headers="props">
            <tr style="background-color: #152d53; color: white">
              <th
                style="background-color: #152d53; color: yellow"
                v-for="header in props.headers"
                :key="header.text"
                class="text-xs-left"
                :class="[
                  'column sortable',
                  pagination.descending ? 'desc' : 'asc',
                  header.value === pagination.sortBy ? 'active' : ''
                ]"
                @click="changeSort(header.value)"
              >
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template v-slot:items="props">
            <tr class="py-3 depatable">
              <td class="text-xs-left">
                <Typography h5 :label="props.item.formname ? props.item.formname : '-'" />
              </td>
              <td style="white-space: nowrap" @click.stop="" class="text-xs-center">
                <TooltipTable
                  :datas="props"
                  @modalEdit="showEdit(props.item), (isEdit = true)"
                  @Copy="showCopy(props.item)"
                  @Delete="deleteForm(props.item.id)"
                  @ViewExample="viewFormData(props.item)"
                  showDelete
                  showCopy
                  showViewExample
                ></TooltipTable>
              </td>
              <!-- <td class="text-xs-right">
                <v-btn @click="showEdit(props.item)" icon outline>
                  <i :color="$vuetify.theme.primary" class="fas fa-pencil-alt"></i>
                </v-btn>
                <v-btn @click="showCopy(props.item)" icon outline>
                  <i :color="$vuetify.theme.primary" class="fa fa-copy middle"></i>
                </v-btn>
                <v-btn @click="deleteForm(props.item.id)" icon outline>
                  <v-icon color="primary">delete</v-icon>
                </v-btn>
              </td> -->
            </tr>
          </template>
        </v-data-table>
        <div>
          <v-dialog v-model="editModal" persistent width="740px">
            <v-card>
              <CustomFormManager
                v-if="editModal"
                @onCreate="onCreateForm"
                @onUpdate="onUpdateForm"
                :editType="editType"
                :editdata="editdata"
                @close="closemodal"
              ></CustomFormManager>
            </v-card>
          </v-dialog>
        </div>
        <div>
          <v-dialog v-model="modalPreview" width="800px" style="overflow: hidden;">
            <v-card>
              <FormDetail
                v-if="modalPreview"
                :formdata="{
                  formname: formname,
                  button: button,
                  reject: reject,
                  formitems: formitems
                }"
                :showPreview="true"
                :showSubquestion="true"
                @close="modalPreview = false"
              ></FormDetail>
            </v-card>
          </v-dialog>
        </div>
      </div>
    </div>
    <Paginations
      @clickPagination="changepage"
      @sortPage="sortPage"
      :pageCount="pageCount"
      :numberPage="numberPage"
      :page="page"
    />
  </div>
</template>

<script>
import InputSearch from '@/components/elements/InputSearch.vue'
import Paginations from '@/components/elements/Paginations.vue'
import ProjectInfoEdit from './ProjectInfoEdit.vue'
import CustomFormManager from './CustomFormManager.vue'
import Multiselect from 'vue-multiselect'
import Typography from '@/components/elements/Typography.vue'
import TooltipTable from '@/components/elements/TooltipTable.vue'
import Button from '@/components/elements/Button.vue'
import moment from 'moment'
import api from '@/api'

export default {
  components: {
    ProjectInfoEdit,
    CustomFormManager,
    Multiselect,
    InputSearch,
    TooltipTable,
    Paginations,
    Typography,
    Button
  },

  data() {
    return {
      page: 1,
      numberPage: {
        page: undefined
      },
      pageTotal: 0,
      loading: true,
      search: { formname: '' },
      pagination: {
        sortBy: 'formname',
        descending: false,
        rowsPerPage: 50
      },
      showSearch: false,
      editType: '',
      test: false,
      editdata: {},
      editModal: false,
      modalPreview: false,
      formdata: [],
      headers: [
        {
          text: 'ชื่อฟอร์ม',
          align: 'center',
          value: 'name'
        },

        {
          text: '',
          align: 'center',
          value: ''
        }
      ],
      button: 'อนุมัติ',
      reject: 'ไม่อนุมัติ',
      formname: '',
      formitems: [
        {
          hideFromMember: false,
          name: '',
          questiontype: 'ข้อความ',
          fields: [],
          isRequired: false,
          value: '',
          value2: '',
          fields2: [],
          digitPosition: 0,
          filename: '',
          fileurl: '',
          defaultOptions: []
        }
      ]
    }
  },
  mounted() {
    this.getData()
  },
  computed: {
    filteredform() {
      return this.formdata
    },
    pageCount() {
      if (this.formdata && this.pageTotal) {
        let count = Math.ceil(this.pageTotal / this.pagination.rowsPerPage)
        return count
      } else {
        return 0
      }
    },
    limitCom() {
      return this.pagination.rowsPerPage
    },
    offsetCom() {
      return this.page ? this.page * this.pagination.rowsPerPage - this.pagination.rowsPerPage : this.pagination.rowsPerPage
    }
  },
  methods: {
    async sortPage(pages) {
      let count = Math.ceil(this.pageTotal / this.pagination.rowsPerPage)
      if (pages == '' || Number(pages <= 0) || pages > Number(count)) return
      this.page = parseInt(pages)
      this.loading = true
      await this.getData()
      this.loading = false
    },
    async changepage(pages) {
      this.page = parseInt(pages)
      this.numberPage.page = undefined
      this.loading = true
      await this.getData()
      this.loading = false
    },
    async onSearch() {
      this.loading = true
      this.searchloading = true
      await this.getData()
      this.searchloading = false
      this.showSearch = false
      this.loading = false
    },
    async clearSearch() {
      this.search = { formname: '' }
      this.searchloading = true
      await this.getData()
      this.searchloading = false
      this.showSearch = false
    },
    viewFormData(item) {
      this.editdata = item
      if (this.editdata) {
        var formdata = JSON.parse(this.editdata.formdata)
        this.button = formdata.button
        this.reject = formdata.reject
        if (this.editType == 'copy') {
          this.name = this.editdata.formname + '_copy'
        } else {
          this.name = this.editdata.formname
        }
        this.formname = this.editdata.formname
        this.formitems = formdata.formitems
        this.modalPreview = true
      }
    },
    getData() {
      return new Promise(resolve => {
        var search = {}
        for (const [key, value] of Object.entries(this.search)) {
          if (value) {
            Object.assign(search, { [key]: value })
          }
        }
        console.log('search', search)
        api.getdepaprojectform(
          {
            formname: search.nameAll,
            pageid: this.selectedBot.pageid,
            limit: this.limitCom,
            offset: this.offsetCom
          },
          (err, response) => {
            this.loading = false
            if (response.responsecode == 200) {
              this.formdata = response.data
              this.pageTotal = response.total
              resolve()
            }
          }
        )
      })
      // this.loading = true
    },
    onCreateForm(data) {
      // this.editdata = data
      this.editType = 'edit'
      // this.formdata.push(data)
      this.$swal.fire({
        type: 'success',
        title: '<div class="headline primary--text bold7 fs-24">บันทึกข้อมูลสำเร็จ</div>',
        confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
      })
      this.getData()
      this.$nextTick(() => {
        this.editModal = false
      })
    },
    onUpdateForm(data) {
      // var index = this.formdata.findIndex(el => el.id == data.formid)
      // this.formdata[index] = data
      // this.$set(this.formdata, index, data)
      this.$swal.fire({
        type: 'success',
        title: '<div class="headline primary--text bold7 fs-24">บันทึกข้อมูลสำเร็จ</div>',
        confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
      })
      this.getData()
      this.$nextTick(() => {
        this.editModal = false
      })
    },
    deleteForm(id) {
      this.$swal
        .fire({
          title:
            '<img src="/static/img/delete.png" alt class="responsive-img mt-4" style="height: 73px" />',
          html: `<div class="primary--text fs-16 mt-2 mb-3" style="font-weight:600;">คุณต้องการลบแบบฟอร์มโครงการนี้ใช่หรือไม่?</div>`,
          showCancelButton: true,
          showCloseButton: true
        })
        .then(async result => {
          if (result.value) {
            let res = await api.deletedepaprojectform({ formid: Number(id) })
            if (res.status === 200) {
              await this.getData()
              this.$swal.fire({
                type: 'success',
                title: '<div class="headline primary--text bold7 fs-24">ลบข้อมูลสำเร็จ</div>',
                confirmButtonText: '<span style="color:#FFEF01">ปิด</span>'
              })
            } else {
              this.$swal.fire('ลบข้อมูลไม่สำเร็จ')
            }
          }
        })
      // .then(result => {
      //   if (result.value) {
      //     api.deletedepaprojectform({ formid: id }, (err, response) => {
      //       if (response.responsecode == 200) {
      //         var index = this.formdata.findIndex(el => el.id == id)
      //         this.formdata.splice(index, 1)
      //       }
      //     })
      //   }
      // })
    },
    showCustomform() {
      this.editType = 'add'
      this.editModal = true
      console.log(this.editModal)
    },
    statusColor(status) {
      if (status == 'Active') return 'green'
      else if (status == 'Inactive') return 'red'
    },
    saveedit(item) {
      var index = this.formdata.findIndex(el => el.id == item.id)
      this.formdata[index] = item
      this.editModal = false
    },
    closemodal() {
      this.editModal = false
    },
    showEdit(item) {
      this.editdata = item
      this.editType = 'edit'
      this.editModal = true
    },
    showCopy(item) {
      this.editdata = item
      this.editType = 'copy'
      this.editModal = true
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fixTable table.v-table {
  thead {
    tr {
      th:last-child {
        position: sticky !important;
        position: -webkit-sticky !important;
        right: 0;
        filter: drop-shadow(0px 2px 5px #d9d9d9);
      }
      th:last-child::after {
        content: '';
        border-left: 0;
      }
    }
  }
  tbody {
    tr {
      td:not(:last-child) {
        vertical-align: middle;
      }
      td:last-child {
        position: sticky !important;
        position: -webkit-sticky !important;
        background-color: #ffffff;
        right: 0;
        filter: drop-shadow(0px 2px 5px #d9d9d9);
        vertical-align: middle;
      }
      td:last-child::after {
        content: '';
        border-left: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/projectMaster/ProjectForm.vue